/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.PackageLookup {
    angular.module("meevo.plugins.packageLookup", []);
}